// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2tWWs","name":"Header_name__Xh3sM","birthday":"Header_birthday__FrJyZ","skeleton":"Header_skeleton__2LhJk"};